'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders } from '@awesome.me/kit-94e593bf23/icons/classic/light'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'

const CategoryNav = dynamic(() => import('./CategoryNav'), { ssr: false })

const CategoryDesigner = ({ category }) => {

    // Children are now pre-sorted arrays from PHP cache
    const children = category.children || []

    return (
        <div className="flex flex-col lg:flex-row align-start">
            <aside className="relative flex flex-col items-start h-full hidden lg:block w-[225px] min-w-[225px] mr-12 pt-4">
                <div className="flex items-center border-b-1 border-gray-8 pb-3">
                    <FontAwesomeIcon icon={faSliders} className="text-primary text-xl mr-3" width="16" />
                    <span className="text-md text-primary">Filter</span>
                </div>
                <CategoryNav category={category} />
            </aside>
            <div className="pb-[150px] w-full pt-4">
                <div className="flex items-center mb-3">
                    <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-xl mr-1" />
                    <h1 className="text-xl text-light font-extralight block capitalize">{category.display_name || category.category_name}</h1>
                </div>
                <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 xl:grid-cols-4 xl:gap-8 2xl:grid-cols-5 2xl:gap-10">
                    {children.map((subCategory, index) => (
                        subCategory.images?.landing?.file_name &&
                            <Link key={subCategory.category_id || index} href={subCategory.url} className="group">
                                <div className="overlay-block">
                                    <Image
                                        src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory.images.landing.file_name}`}
                                        overrideSrc={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${subCategory.images.landing.file_name}`}
                                        alt={subCategory.images.landing.alt || subCategory.category_name}
                                        placeholder="blur"
                                        blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII="
                                        width={subCategory.images.landing.width}
                                        height={subCategory.images.landing.height}
                                    />
                                </div>
                                {/* Use display_name ("First Last") instead of category_name ("Last, First") for readability */}
                                <div className="text-lg capitalize mt-3 group-hover:text-primary">{subCategory.display_name || subCategory.category_name}</div>
                            </Link>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CategoryDesigner
